import { inject, Injectable } from '@angular/core';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import { DvDropdownLoaderParams } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { DropdownContext } from '@shared/dv-form/interfaces/dropdown-context';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DvDropdownDatasourceService {
  private api = inject(RestApiService);
  private translate = inject(TranslateService);

  loader = async <T = any>(
    params: DvDropdownLoaderParams<T, DropdownContext<T>>
  ): Promise<T[]> => {
    const { endRow, columns, startRow, searchTerm } = params;
    const fields = (columns
      ?.filter(({ field }) => !!field)
      .map(({ field }) => field) ?? []) as string[];
    const {
      filterModel = {},
      sortModel,
      entity,
    } = params.context as DropdownContext<T>;

    const body: GetRowsRequest = {
      fields,
      endRow,
      filterModel,
      quickFilterText: searchTerm,
      sortModel,
      startRow,
      entity,
    };

    if (!isNaN(endRow)) {
      Object.assign(body, { endRow: endRow ? endRow : 100 });
    }

    if (!isNaN(startRow)) {
      Object.assign(body, { startRow });
    }
    const request = this.api.getData(body);
    const response = await firstValueFrom(request);

    if (!params.context?.translateLabels?.length) {
      return response.data;
    }

    return response.data?.map((item: any) => {
      const translated = { ...item };
      for (const key of params.context!.translateLabels!) {
        if (typeof translated[key] === 'string') {
          translated[key] = this.translate.instant(translated[key]);
        }
      }
      return translated;
    });
  };
}
